import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { English } from '../../intl/locale-context-provider/locale-codes';
import { useLocale } from '../../intl/hooks';

import { translateTokensToLanguage } from './helpers';

const EnglishOnly = ({ intlFrom, model, onChange }) => {
  const { setLocale } = useLocale();
  const intlTo = useIntl();

  useEffect(() => {
    setLocale(English, false);
  }, [setLocale]);

  useEffect(() => {
    onChange(translateTokensToLanguage(model, intlFrom, intlTo));
  }, [intlFrom, intlTo, model, onChange]);

  return null;
};

EnglishOnly.propTypes = {
  intlFrom: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
  model: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default EnglishOnly;
